import script from "./PasswordTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordTab.vue?vue&type=script&setup=true&lang=js"

import "./PasswordTab.vue?vue&type=style&index=0&id=6f11498f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f11498f"]])

export default __exports__